import hotkeys from 'hotkeys-js'
import { hotkeySequence } from '@/hotkeys/useHotkeys'
import { ref } from 'vue'
import { PanelContent } from '@tritt/multipanel'
import { setPanelCount, usePanelManager } from '@tritt/multipanel'

type FeatureHotkey = { key: string, route: PanelContent }

export const featureHotkeys = ref<FeatureHotkey[]>([])
const panelIds = [1, 2, 3, 4]

for (const panelId of panelIds) {
    hotkeys('ctrl+shift+' + panelId, () => {
        setPanelCount(panelId)
    })
}

export const registerHotkey = (key: string, route: PanelContent) => {
    featureHotkeys.value.push({ key, route })
    for (const panelId of panelIds) {
        hotkeySequence(['g', key, panelId.toString()], () => {
            const { setPanelPath } = usePanelManager()
            setPanelPath({ ...route, panelId, isFromHotkey: true })
        })
    }
}